// page/System/router.js
// System菜单下管理的路由文件
export default [{
		path: '/financialDepartmentbudget',
		component: () => import('./Departmentbudget.vue'),
		name: 'Departmentbudget',
		meta: {
			title: 'Sidebar.financelsubsTitle[0]'
		}
	},
	{
		path: '/financialDepartmentBudgetlist',
		component: () => import('./DepartmentBudgetlist.vue'),
		name: 'DepartmentBudgetlist',
		meta: {
			title: 'Sidebar.financelsubsTitle[1]'
		}
	},
	{
		path: '/financialMonthClosureaccount',
		component: () => import('./MonthClosureaccount.vue'),
		name: 'MonthClosureaccount',
		meta: {
			title: 'Sidebar.financelsubsTitle[2]'
		}
	},
	{
		path: '/financialPaymentOrderList',
		component: () => import('./PaymentOrderList.vue'),
		name: 'PaymentOrderList',
		meta: {
			title: 'Sidebar.financelsubsTitle[3]'
		}
	},
	{
		path: '/financialAccountingSubjectManager',
		component: () => import('./AccountingSubjectManager.vue'),
		name: 'AccountingSubjectManager',
		meta: {
			title: 'Sidebar.financelsubsTitle[4]'
		}
	},
	{
		path: '/financialInvoiceManagement',
		component: () => import('./InvoiceManagement.vue'),
		name: 'InvoiceManagement',
		meta: {
			title: 'Sidebar.financelsubsTitle[5]'
		}
	}
];



// WEBPACK FOOTER //
// ./src/components/page/financial/router.js